import { paths } from '@/app/paths';
import { NewBusinessIcon } from '@/components/icons/NewBusinessIcon';
import { ClaimsIcon } from '@/components/icons/ClaimsIcon';
import { EndorsementIcon } from '@/components/icons/Endorsement';
import { RenewalIcon } from '@/components/icons/Renewal';

export const addMenuList = [
	{
		text: 'Add New Business',
		Icon: NewBusinessIcon,
		link: paths.createNewBusiness,
	},
	{
		text: 'Add Claim',
		Icon: ClaimsIcon,
		link: paths.createClaim,
	},
	{
		text: 'Add Endorsement',
		Icon: EndorsementIcon,
		link: paths.createEndorsement,
	},
	{
		text: 'Add Renewal',
		Icon: RenewalIcon,
		link: paths.createRenewal,
	},
];
